"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var react_2 = require("@transifex/react");
var styled_components_1 = __importDefault(require("styled-components"));
var InquiryStatus_1 = __importDefault(require("../../Tag/InquiryStatus"));
var InquiryPriority_1 = __importDefault(require("../../Tag/InquiryPriority"));
var progress_1 = require("./progress");
var utils_1 = require("./utils");
var transifex_1 = require("../../../transifex");
var StyledBodyLabel = styled_components_1.default(antd_1.Typography.Paragraph)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #9bafc2;\n  font-weight: 400;\n  font-size: 14px;\n  margin-bottom: 0.5em !important;\n"], ["\n  color: #9bafc2;\n  font-weight: 400;\n  font-size: 14px;\n  margin-bottom: 0.5em !important;\n"])));
var StyledBodyValue = styled_components_1.default(antd_1.Typography.Paragraph)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: #111d2c;\n  font-weight: 400;\n  font-size: 14px;\n  margin-bottom: 0.5em !important;\n"], ["\n  color: #111d2c;\n  font-weight: 400;\n  font-size: 14px;\n  margin-bottom: 0.5em !important;\n"])));
var StyledBodyValueWithBox = styled_components_1.default(antd_1.Typography.Paragraph)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: #111d2c;\n  font-weight: 400;\n  font-size: 12px;\n  border: 1px solid #d9d9d9;\n  background-color: #fafafa;\n  box-sizing: border-box;\n  border-radius: 2px;\n  max-height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n  float: left;\n"], ["\n  color: #111d2c;\n  font-weight: 400;\n  font-size: 12px;\n  border: 1px solid #d9d9d9;\n  background-color: #fafafa;\n  box-sizing: border-box;\n  border-radius: 2px;\n  max-height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n  float: left;\n"])));
var StyledHeading = styled_components_1.default(antd_1.Typography.Paragraph)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 14px;\n  color: #0f3f6b;\n  font-weight: 600;\n"], ["\n  font-size: 14px;\n  color: #0f3f6b;\n  font-weight: 600;\n"])));
var StyledDivider = styled_components_1.default(antd_1.Divider)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: #dee4eb;\n  min-width: 95%;\n  margin-top: 10px;\n"], ["\n  color: #dee4eb;\n  min-width: 95%;\n  margin-top: 10px;\n"])));
var LongToolTip = function (_a) {
    var data = _a.data;
    var location = data.location, stopNumber = data.stopNumber, fillLevel = data.fillLevel, completedAt = data.completedAt, scheduledDriverArrival = data.scheduledDriverArrival, wasteFraction = data.wasteFraction, stopsCount = data.stopsCount, weight = data.weight, status = data.status, priority = data.priority, inquiryTyping = data.inquiryTyping, createdAt = data.createdAt, reporter = data.reporter;
    var items = [
        {
            label: transifex_1.TX_INQUIRIES_INFORMATION,
            value: "",
        },
        {
            label: transifex_1.TX_SCHEDULED,
            value: react_1.default.createElement(react_2.T, { _str: scheduledDriverArrival }),
        },
        {
            label: transifex_1.TX_LOCATION,
            value: react_1.default.createElement(react_2.T, { _str: utils_1.getValue(location.name) }),
        },
        {
            label: transifex_1.TX_WASTE_FRACTION,
            value: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(StyledBodyValueWithBox, null,
                    react_1.default.createElement(react_2.T, { _str: utils_1.getValue(wasteFraction === null || wasteFraction === void 0 ? void 0 : wasteFraction.wasteSubstance) })),
                react_1.default.createElement(StyledBodyValueWithBox, { style: {
                        marginLeft: 8,
                    } },
                    react_1.default.createElement(react_2.T, { _str: utils_1.getValue(wasteFraction === null || wasteFraction === void 0 ? void 0 : wasteFraction.wasteCategory) })))),
        },
        {
            label: transifex_1.TX_STOPS,
            value: react_1.default.createElement(react_2.T, { _str: utils_1.getValue(stopNumber) + " / " + utils_1.getValue(stopsCount) }),
        },
        {
            label: completedAt === null ? transifex_1.TX_FILL_LEVEL : transifex_1.TX_WEIGHT,
            value: completedAt === null ? (react_1.default.createElement(progress_1.ProgressFilledLevel, { fillLevel: fillLevel, isLongToolTip: true })) : (react_1.default.createElement(react_2.T, { _str: utils_1.getValue(weight) !== "-"
                    ? utils_1.getValue(weight) + " kg"
                    : utils_1.getValue(weight) })),
        },
    ];
    var inquiryItems = [
        {
            label: transifex_1.TX_INQUIRIES_INFORMATION,
            value: "",
        },
        {
            label: transifex_1.TX_STATUS_PRIORITY,
            value: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(InquiryStatus_1.default, { title: status }),
                react_1.default.createElement(InquiryPriority_1.default, { title: priority }))),
        },
        {
            label: transifex_1.TX_INQUIRY_TYPE,
            value: react_1.default.createElement(react_2.T, { _str: utils_1.getValue(inquiryTyping) }),
        },
        {
            label: transifex_1.TX_CREATED_DATE,
            value: react_1.default.createElement(react_2.T, { _str: utils_1.getValue(createdAt) }),
        },
        {
            label: transifex_1.TX_CREATED_BY,
            value: (react_1.default.createElement(react_2.T, { _str: utils_1.getValue(reporter === null || reporter === void 0 ? void 0 : reporter.firstName) + " " + utils_1.getValue(reporter === null || reporter === void 0 ? void 0 : reporter.lastName) })),
        },
    ];
    var HeadContent = function (_a) {
        var name = _a.name;
        return (react_1.default.createElement(antd_1.Row, { style: { marginTop: 10 } },
            react_1.default.createElement(antd_1.Col, { xs: 8 },
                react_1.default.createElement(StyledHeading, null,
                    react_1.default.createElement(react_2.T, { _str: name }))),
            react_1.default.createElement(antd_1.Col, { xs: 16 },
                react_1.default.createElement(StyledDivider, null))));
    };
    var BodyContent = function (_a) {
        var item = _a.item, index = _a.index;
        return (react_1.default.createElement(antd_1.Row, { style: { marginTop: index === 1 ? 10 : 0 } },
            react_1.default.createElement(antd_1.Col, { xs: 10 },
                react_1.default.createElement(StyledBodyLabel, null, item.label)),
            react_1.default.createElement(antd_1.Col, { xs: 14 },
                react_1.default.createElement(StyledBodyValue, null, item.value))));
    };
    return (react_1.default.createElement(antd_1.Row, { style: {
            minWidth: 520,
            maxWidth: 520,
        } },
        react_1.default.createElement(antd_1.Col, { span: 24, style: { padding: 10 } },
            items.map(function (item, index) {
                return index === 0 ? (react_1.default.createElement(HeadContent, { name: "Container Information" })) : (react_1.default.createElement(BodyContent, { item: item, index: index, key: item.label }));
            }),
            inquiryTyping && (react_1.default.createElement(react_1.default.Fragment, null, inquiryItems.map(function (inq, ind) {
                return ind === 0 ? (react_1.default.createElement(HeadContent, { name: "Inquiries Information" })) : (react_1.default.createElement(BodyContent, { item: inq, index: ind, key: inq.label }));
            }))))));
};
exports.default = LongToolTip;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
